export default __webpack_public_path__ + "static/media/iran.1b7340f7.png";